const listPointsBody = document.querySelector('#filmAFConsider').querySelector('div[name=body]');

// import auth from '../tools/storage.js';
import auth from '../tools/storage.js';
import tools from '../tools/tools.js';

export default {

  cleanContainer() {
    listPointsBody.innerHTML = '';
  },

  getElement(item, index) {

    let premiereStatus = '';
    
    let fcID = ` fCID=${item.id} numReq=${item.id} `;

    if(parseInt(item.premiere, 10) === 1)
      premiereStatus = `<div class = "premiere-icon premiere-icon-russia"></div>`;
    else   if(parseInt(item.premiere, 10) === 2)
      premiereStatus = `<div class = "premiere-icon  premiere-icon-world"></div>`;
    

    return `<div class="reference-header  m-0 p-1 " ${fcID}> 
            <div  class="reference-column m-0 p-0"> 
              <label ${fcID}  class=" p-0 m-0 iconGroupOfConsider">${item.id  }</label>
            </div>  
            <label ${fcID}  class="reference-column m-0 p-0 pl-1">${item.name} ${premiereStatus}</label>
          </div>`;
  },

  drawDataInContainer(listWithData) {
    this.cleanContainer();

    let HTMLBODY = '';

    // console.log(typeSort.value);

    if(listWithData) {

      listPointsBody.classList.remove('row');
      listPointsBody.classList.remove('column');
      listPointsBody.classList.add('column');
      HTMLBODY =`
          <div class="reference-header firstRow">
              <div class="reference-column">№</div>
              <div class="reference-column">Название работы</div>
          </div>`;
      listWithData.forEach((item, index) => {
        HTMLBODY += this.getElement(item, index);
      });
      listPointsBody.innerHTML = HTMLBODY;
    } else
      listPointsBody.innerHTML = 'Данных пока нет';
  },


  drawMarkupInContainer(markup) {
    listPointsBody.insertAdjacentHTML('beforeend', markup);
  },

};
